import 'css-chunksrc/client/scenes/projectCreationForm/dateForm/styles.scss';export default {
  "dateForm": "_dateForm_1e15h_1",
  "group": "_group_1e15h_6",
  "wrapper": "_wrapper_1e15h_13",
  "calendar": "_calendar_1e15h_22",
  "icon": "_icon_1e15h_49",
  "titleStart": "_titleStart_1e15h_55",
  "titleEnd": "_titleEnd_1e15h_61",
  "input": "_input_1e15h_68"
};